import { PurchaseOrder, PurchaseOrderStatus } from '@jms/model';

import { defineStatusTag } from '../../shared/define.status.tag';

// Single source of Purchase Order status colour. One function feeds both the manifest's board-card
// tag style and the manage surface header's tag deriver, so the two can never drift.
//
// The seven active statuses carry the tones declared on `purchaseOrderLifecycle`. The deprecated
// statuses below it are not on the lifecycle at all — they are legacy migration values that must
// still render if stored data carries them, so they are toned here rather than being allowed to
// fall through to the unknown-value fallback.
export const purchaseOrderStatusTag = defineStatusTag<PurchaseOrderStatus, PurchaseOrder>({
  [PurchaseOrderStatus.Draft]: 'neutral',
  [PurchaseOrderStatus.PendingApproval]: 'warning',
  [PurchaseOrderStatus.ChangesRequired]: 'warning',
  [PurchaseOrderStatus.Approved]: 'brand',
  [PurchaseOrderStatus.AwaitingDelivery]: 'brand',
  [PurchaseOrderStatus.Billed]: 'success',
  [PurchaseOrderStatus.Cancelled]: 'error',

  [PurchaseOrderStatus.Void]: 'error',
  [PurchaseOrderStatus.Submitted]: 'neutral',
  [PurchaseOrderStatus.SubmittedForApproval]: 'neutral',
  [PurchaseOrderStatus.Authorised]: 'neutral',
  [PurchaseOrderStatus.Reconciled]: 'neutral',
  [PurchaseOrderStatus.Error]: 'neutral',
}, 'neutral');
